module.exports = __webpack_public_path__ + "img/bot_max.ad1f7208.jpg";